import { apiPost } from "./client.ts";

// (TF3-3) the legacy segment regenerate / image and the SeedDance preview are retired (the backend answers 410); an
//  engine video's storyboard is approved at its run's gate (EngineReview).
export const storyboardsApi = {
  approve: (videoId: string) =>
    apiPost<{ ok: boolean }>(`/videos/${videoId}/storyboard/approve`),
};
